import { useLoginInfoQuery } from "Services";
import { LoginInfoResponse } from "Types";

type UseLoginInfo = {
  isSSOLogin: boolean;
  isLocalLogin: boolean;
  ssoInfo: LoginInfoResponse["sso_info"] | null;
  isInFlight: boolean;
  hasLoaded: boolean;
  refetchLoginInfo: () => void;
};

const useLoginInfo = (): UseLoginInfo => {
  const {
    data: loginInfo,
    isSuccess,
    isLoading,
    isFetching,
    refetch,
  } = useLoginInfoQuery();

  return {
    isSSOLogin: isSuccess ? loginInfo.sso_enabled : true,
    isLocalLogin: isSuccess ? !loginInfo.sso_enabled : true,
    ssoInfo: loginInfo?.sso_info || null,
    isInFlight: isLoading || isFetching,
    hasLoaded: isSuccess,
    refetchLoginInfo: refetch,
  };
};

export default useLoginInfo;
